import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { TabbedPageLayoutComponent } from 'app/layout/page-layouts/tabbed/tabbed-page-layout.component';
import { PermissionGuard } from 'app/core/permissions/permissions.guard';

export const testRoutes: Route[] = [
    {
        path: 'test',
        canActivate: [AuthGuard],
        component: LayoutComponent,
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full',
            },
            {
                path: 'dashboard',
                component: TabbedPageLayoutComponent,
                children: [
                    {
                        path: '',
                        data: {
                            tabs: [],
                        },
                        loadComponent: () =>
                            import('./pages/dashboard.component').then(
                                (c) => c.DashboardComponent
                            ),
                    },
                ],
            },
        ],
    },
];
